import { createRoute, lazyRouteComponent } from '@tanstack/react-router'

import { client } from '@authy/lib-client/trpc'

import { rootRoute } from '@/tenant/settings/root'
import { appState } from '@/appState'

export const appearanceRoute = createRoute({
    getParentRoute: () => rootRoute,
    path: '/appearance',
    component: lazyRouteComponent(() => import('./Appearance'), 'Appearance'),
    loader: async ({ abortController, parentMatchPromise }) => {
        await parentMatchPromise

        const presenterSettings = await client.tenants.presenter.getPresenterSettings.query(
            {
                tenantId: appState.tenant!._id.toString(),
            },
            { signal: abortController.signal }
        )

        return { presenterSettings }
    },
})
